import React from 'react';
import { Icon } from './Icon.js';
export const IconGridLayout3Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M3.5 11H1.75C0.783502 11 0 10.2165 0 9.25V2.75C0 1.7835 0.783502 1 1.75 1H3.5V11Z", fill: "currentColor" }),
        React.createElement("path", { d: "M12 6V9.25C12 10.2165 11.2165 11 10.25 11H5V6H12Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M10.25 1C11.2165 1 12 1.7835 12 2.75V4.5H5V1H10.25Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconGridLayout3Fill12.js.map